// @ts-nocheck
import { OrderChangeRequestLineModel, OrderChangeRequestNewLineModel } from "@store/Framework/Types/ApiModels";

type OrderChangeRequestDirtyState = {
    orderLines?: OrderChangeRequestLineModel[];
    newLines?: OrderChangeRequestNewLineModel[];
    newPoNumber?: string;
    newRequestedDate?: Date;
    newShipToCode?: string;
};

const getOrderChangeRequestHasChanges = (changeRequestOrder?: OrderChangeRequestDirtyState) => {
    if (!changeRequestOrder) {
        return false;
    }

    const { orderLines, newLines, newPoNumber, newRequestedDate, newShipToCode } = changeRequestOrder;
    const allLines = [...(orderLines ?? []), ...(newLines ?? [])];
    const hasLineLevelChanges = allLines.some(x => x.changeReason || x.changeNotes || x.newQuantity);
    const hasOrderLevelChanges = !!(newPoNumber?.trim() || newRequestedDate || newShipToCode);

    return hasLineLevelChanges || hasOrderLevelChanges;
};

export default getOrderChangeRequestHasChanges;
